<template>
  <div class="page">
    <YorkbbsHeader>
      <el-breadcrumb-item :to="{ name: 'Home' }">约克汽车</el-breadcrumb-item>
      <template v-if="$route.params.topic === 'used'">
        <el-breadcrumb-item to="/list/used">二手车</el-breadcrumb-item>
        <el-breadcrumb-item> 发布二手车</el-breadcrumb-item>
      </template>
      <template v-else-if="$route.params.topic === 'lease'">
        <el-breadcrumb-item to="/list/lease">转lease</el-breadcrumb-item>
        <el-breadcrumb-item>发布转lease</el-breadcrumb-item>
      </template>
    </YorkbbsHeader>
    <section class="page-wrapper">
      <el-form class="page-left" label-width="100px" label-position="left" size="medium">
        <!-- 房屋照片 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">车辆照片</strong>
            <span class="form-header__required">* 必填项</span>
          </div>
          <YorkbbsUpload :fileList.sync="form.imageList" :uploadLimit="9">
            <div class="form-upload__tip">
              最多9张（单张不超过15M），支持批量上传，默认第一张图片为封面图，图片可拖拽
            </div>
          </YorkbbsUpload>
        </div>
        <!-- 车辆信息 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">车辆信息</strong>
          </div>
          <el-form-item label-width="0">
            <div class="cont-row">
              <div class="flex-cont">
                <div class="forum-column-label"> <span class="required">*</span>品牌</div>
                <el-select
                  class="form-select"
                  v-model="form.brand"
                  filterable
                  @change="getModals"
                  :filter-method="brandFilterMethod"
                  placeholder="请选择或输入品牌"
                >
                  <el-option-group label="默认按英文首字母排序">
                    <el-option v-for="item in brandFilters" :key="item.id" :label="item.nameCN" :value="item.id">
                      <span class="form-select__cn">{{ item.nameCN }}</span>
                      <span class="form-select__en">{{ item.name }}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
              <div style="width:20px"></div>
              <div class="flex-cont">
                <div class="forum-column-label"> <span class="required">*</span>年份</div>
                <el-select class="form-select" v-model="form.year" filterable @change="generateTitle">
                  <el-option v-for="item in years" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
              <div style="width:20px"></div>

              <div class="flex-cont">
                <div class="forum-column-label"> <span class="required">*</span>型号</div>
                
                <el-select class="form-select" v-model="form.modal" filterable @change="generateTitle">
                  <el-option v-for="item in modals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            
          </el-form-item>
          <el-form-item label-width="0">
            <div class="cont-row">
              <div class="flex-cont">
                <div class="forum-column-label"> <span class="required">*</span>车型</div>
                <el-select class="form-select" v-model="form.mould" filterable>
                  <el-option v-for="item in moulds" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
              <div style="width:20px"></div>
              <div class="flex-cont">                
              </div>
              <div style="width:20px"></div>
              <div class="flex-cont"></div>
            </div>

          </el-form-item>
        </div>
        <!---价格模式-->
        <div class="form-section" v-if="$route.params.topic === 'used'">
          <div class="form-header">
            <strong class="form-header__name">二手车</strong>
          </div>
          <template>
            <div class="cont-row">
              <div class="cont dir-column">
                <div class="forum-column-label"> <span class="required">*</span>售出价格</div>
                <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.price">
                  <span slot="prefix">$</span>
                </YorkbbsNumberInput>
              </div>
              <div style="width:20px"></div>

              <div class="cont dir-column">
                <div class="forum-column-label"> <span class="required">*</span>现公里数</div>
                <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.existingKM">
                  <span slot="suffix">km</span>
                </YorkbbsNumberInput>
              </div>
            </div>

            <!-- <el-form-item label="价格" required>
              <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.price">
                <span slot="prefix">$</span>
              </YorkbbsNumberInput>
            </el-form-item>
            <el-form-item label="现公里数" required>
              <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.existingKM">
                <span slot="suffix">km</span>
              </YorkbbsNumberInput>
            </el-form-item> -->
          </template>
        </div>
        <!----->
        <!--转lease价格--->
        <div class="form-section" v-if="$route.params.topic === 'lease'">
          <div class="form-header">
            <strong class="form-header__name">转Lease</strong>
          </div>
          <template>
            <el-form-item label-width="0">
              <div class="cont-row">
                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>原首付</div>
                  
                  <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.preDownPayments">
                  <span slot="prefix">$</span>
                </YorkbbsNumberInput>
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>拿回首付（返现请填负数）</div>
                  <YorkbbsNumberInput class="form-input" :min="-9999999" :max="9999999" :precision="0" v-model="form.downPayments" :negative="true">
                    <span slot="prefix">$</span>
                  </YorkbbsNumberInput>
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>税后月供</div>
                  <div><YorkbbsNumberInput
                      class="form-input"
                      :min="0"
                      :max="9999999"
                      :precision="0"
                      v-model="form.monthlySupply"
                    >
                      <span slot="prefix">$</span>
                    </YorkbbsNumberInput></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0">
              <div class="cont-row">
                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>到期时间</div>
                  <div>
                    <el-date-picker
                      class="form-datepicker__item"
                      v-model="form.lastTime"
                      type="month"
                      placeholder="到期时间"
                      format="yyyy年MM月"
                      value-format="yyyyMM"
                      @focus="onLastTimeFocus"
                      :picker-options="{
                        disabledDate(time) {
                          return time.getTime() < Date.now();
                        },
                      }"
                    ></el-date-picker>
                  </div>
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>剩余公里数</div>
                  <div>
                    <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.remainingKM">
                      <span slot="suffix">km</span>
                    </YorkbbsNumberInput>
                  </div>
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>现公里数</div>
                  <div>
                    <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.existingKM">
                      <span slot="suffix">km</span>
                    </YorkbbsNumberInput>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0">
              <div class="cont-row">
                <div class="flex-cont dir-column">
                  <div class="forum-column-label">税前买断</div>
                  
                  <div>
                    <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.buyout">
                      <span slot="prefix">$</span>
                    </YorkbbsNumberInput>
                  </div>

                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label">押金金额</div>
                  
                  <div>
                    <YorkbbsNumberInput class="form-input" :min="0" :max="9999999" :precision="0" v-model="form.deposit">
                      <span slot="prefix">$</span>
                    </YorkbbsNumberInput>
                  </div>
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label">转车费用</div>
                  <div>
                    <el-select v-model="form.transferFeePayer" placeholder="请选择">
                      <el-option label="买家承担" :value="1"></el-option>
                      <el-option label="卖家承担" :value="2"></el-option>
                      <el-option label="双方AA" :value="3"></el-option>
                      <el-option label="面议" :value="4"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0">
              <div class="cont-row">
                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>有无轮胎保险</div>
                  <div>
                    <el-select v-model="form.haveTireInsurance" placeholder="请选择">
                      <el-option label="有" :value="1"></el-option>
                      <el-option label="无" :value="0"></el-option>
                      
                    </el-select>
                  </div>
                  
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label"> <span class="required">*</span>有无还车保险</div>
                  <div>
                    <el-select v-model="form.haveCarInsurance" placeholder="请选择">
                      <el-option label="有" :value="1"></el-option>
                      <el-option label="无" :value="0"></el-option>
                      
                    </el-select>
                  </div>
                </div>
                <div style="width:20px"></div>

                <div class="flex-cont dir-column">
                  <div class="forum-column-label">接车身份限制</div>
                  
                  <div>
                    <el-select v-model="form.buyerLimit" placeholder="请选择">
                      <el-option label="学签、工签、本地人均可" :value="1"></el-option>
                      <el-option label="PR/Citizen/工签持有者可签" :value="2"></el-option>
                      <el-option label="仅限PR/Citizen" :value="3"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-form-item>

           
          </template>
        </div>
        <!-- 更多配置 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">更多配置</strong>
            <span class="form-header__tip">选填项，补充信息获得更多曝光</span>
          </div>
          <el-form-item label="变速箱">
            <el-radio-group class="form-radio__list" v-model="form.gearBox">
              <el-radio class="form-radio__item" v-for="item in gearBoxs" :key="item.id" :label="item.id">{{
                item.name
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="能源">
            <el-radio-group class="form-radio__list" v-model="form.fuelType">
              <el-radio class="form-radio__item" v-for="item in fuelTypes" :key="item.id" :label="item.id">{{
                item.name
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="驱动">
            <el-radio-group class="form-radio__list" v-model="form.drivingType">
              <el-radio class="form-radio__item" v-for="item in drivingTypes" :key="item.id" :label="item.id">{{
                item.name
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="配置">
            <el-checkbox-group class="form-checkbox__list" v-model="form.config">
              <el-checkbox class="form-checkbox__item" v-for="tag in configs" :key="tag.id" :label="tag.id">
                {{ tag.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="标签">
            <el-checkbox-group class="form-checkbox__list" v-model="form.tags">
              <el-checkbox class="form-checkbox__item" v-for="tag in tags" :key="tag.id" :label="tag.id">
                {{ tag.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <!----车辆描述--->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">车辆描述</strong>
          </div>
          <el-form-item label-width="0"> 
            <div>
              <div class="forum-column-label"> <span class="required">*</span>车辆标题  <span class="form-header__tip"  style="margin-left:0">（自动生成，可修改）</span></div>
              <div><el-input v-model="form.title" clearable maxlength="50"></el-input></div>
            </div>
          </el-form-item>
          <el-form-item label-width="0">
            <div class="forum-column-label" style="margin-left:0">车主补充</div>
            <div><YorkbbsEditor ref="editor" @change="onEditorContentChange"></YorkbbsEditor></div>
          </el-form-item>
        </div>
        <!-- 看车地点 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">看车地点</strong>
          </div>
          <el-form-item label="看车地点" required>
            <YorkbbsAddress
              :detailVisible="form.showMyDetailAddress"
              :latitude="form.latitude"
              :longitude="form.longitude"
              :address="form.address"
              :city="form.cityId"
              @change="onAddressChange"
            ></YorkbbsAddress>
          </el-form-item>
        </div>
        <!-- 联系信息 -->
        <div class="form-section">
          <div class="form-header">
            <strong class="form-header__name">联系信息</strong>
          </div>
          <el-form-item label="车主身份" required>
            <el-radio-group class="form-radio__list" v-model="form.source">
              <el-radio class="form-radio-image__item" v-for="item in sources" :key="item.id" :label="item.id">{{
                item.name
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <div class="contact">
              <div class="contact-left">
                <el-form-item label="电话">
                  <YorkbbsPhoneInput class="input-concatnumber" clearable placeholder="请输入加拿大手机号"
                    v-model="form.contactNumber"></YorkbbsPhoneInput>
                </el-form-item>
                <el-form-item label="Email">
                  <el-input class="input-concatnumber" clearable placeholder="请输入Email" v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item label="微信号">
                  <el-input class="input-concatnumber" clearable placeholder="请输入微信账号"
                    v-model="form.weChatId"></el-input>
                </el-form-item>
                <el-form-item label="微信二维码">
                  <YorkbbsUploadbtn :url.sync="form.weChatQrcode" size="mini" type="danger" plain>上传二维码
                  </YorkbbsUploadbtn>
                </el-form-item>
              </div>
              <div class="contact-right">
                <YorkbbsImage width="150px" height="150px" borderRadius="6px" :src="form.weChatQrcode">
                </YorkbbsImage>
              </div>
            </div>

          
        </div>
        <div class="form-submit">
          <el-button type="danger" class="form-button__submit" :loading="submitLoading" @click="savePost"
            >发布</el-button
          >
          <div class="form-submit__tip">
            发布即表明您已承诺以上的所有信息（包含文字及图片）符合加拿大相关法律规定，为合法授权张贴，并愿为此承担全部责任。
          </div>
        </div>
      </el-form>
      <aside class="page-right">
        <YorkbbsServer :questionList="questionList"></YorkbbsServer>
      </aside>
    </section>

    <!-- 底部 -->
    <YorkbbsFooter></YorkbbsFooter>

    <YorkbbsUnauthDialog :visible.sync="unauthVisible"></YorkbbsUnauthDialog>
  </div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
import { topicMapping, years, gearBoxs, fuelTypes, drivingTypes, sources } from '../components/data';
import YorkbbsHeader from '@/common/header/header-simple.vue';
import YorkbbsServer from '@/common/card-server.vue';
import YorkbbsUpload from '@/common/uploader.vue';
import YorkbbsEditor from './editor.vue';
import YorkbbsAddress from '@/common/form-address/form-address.vue';
import YorkbbsNumberInput from '@/common/input/number-input.vue';
import YorkbbsFooter from '@/common/footer/footer-simple.vue';
import YorkbbsPhoneInput from '@/common/input-phone.vue';
import YorkbbsUnauthDialog from '@/common/account/auth/dialog-unauth.vue';
import YorkbbsUploadbtn from '@/common/form-upload/form-upload-button.vue';
export default {
  name: 'Publish',
  components: {
    YorkbbsHeader,
    YorkbbsServer,
    YorkbbsUpload,
    YorkbbsEditor,
    YorkbbsAddress,
    YorkbbsNumberInput,
    YorkbbsFooter,
    YorkbbsPhoneInput,
    YorkbbsUnauthDialog,
    YorkbbsUploadbtn,
  },
  data() {
    return {
      // 品牌列表
      brands: [],
      // 品牌列表用于搜索筛选
      brandFilters: [],
      // 年份列表
      years: years.slice(),
      // 型号列表
      modals: [],
      // 车型列表
      moulds: [],
      // 变速箱列表
      gearBoxs: gearBoxs.slice(1),
      // 能源列表
      fuelTypes: fuelTypes.slice(1),
      // 驱动列表
      drivingTypes: drivingTypes.slice(1),
      // 配置列表
      configs: [],
      // 标签列表
      tags: [],
      // 车主身份列表
      sources: sources.slice(1),
      // 编辑器文本内容
      editorText: '',
      // 到期年份，仅转Lease
      expireYear: undefined,
      // 到期月份，仅转Lease
      expireMonth: undefined,
      // 表单
      form: {
        //标题
        title:'',
        // 分类ID
        // topics: [],
        // 图片列表
        imageList: [],
        // 品牌
        brand: undefined,
        // 年份
        year: undefined,
        // 型号
        modal: undefined,
        // 车型
        mould: undefined,
   
        // 详情介绍
        content: undefined,

        // 二手价格
        price: undefined,
        // 转lease 原首付
        preDownPayments:undefined,
        // 转lease首付，拿回首付，单位分
        downPayments: undefined,
        // 转lease月供，每月还多少钱，单位分
        monthlySupply: undefined,
        // 到期月份，格式202101，数字格式
        lastTime: undefined,
        // 现有公里数，现在已经开了多少公里，单位km
        existingKM: undefined,
        // 剩余公里数，还能开多少公里，剩余的公里数越多，表示可以用的时间越长，就更好卖一些。，单位km
        remainingKM: undefined,
        //转lease 税前买断
        buyout:undefined,
        //转lease 押金金额
        deposit:undefined,
        //转lease 转车费用谁出
        transferFeePayer:undefined,
        //转lease 有无轮胎险
        haveTireInsurance:undefined,
        //转lease 有无还车保险
        haveCarInsurance:undefined,
        //转lease 接车身份限制
        buyerLimit:undefined,


        // 变速箱类型 1手动 2自动
        gearBox: 2,
        // 燃油类型，1汽车，2柴油，3电动 4油电混合
        fuelType: undefined,
        // 驱动类型 1前驱；2后驱；3四驱；4全驱；
        drivingType: undefined,
        // 配置，支持多个
        config: [],
        // 标签：可邮寄等预定义标签
        tags: [],

        // 1 个人私售，2 车行专卖
        source: 1,

        // 所在地址
        address: undefined,
        // 所在城市ID
        cityId: undefined,
        // 是否显示我的详细地址 0不显示 1显示
        showMyDetailAddress: 0,
        // 经度
        longitude: undefined,
        // 纬度
        latitude: undefined,
        // 联系人
        contactName: undefined,
        // 联系人 Email
        email: undefined,
        // 联系电话
        contactNumber: undefined,
        weChatId: '',
        weChatQrcode: '',
      },
      value2:null,
      value3:null,
      // 提交状态
      submitLoading: false,
      // 车辆信息加载状态
      loading: false,

      // 问题列表
      questionList: [
        {
          title: '如何发布二手车/转Lease信息？',
          host: 'forum',
          path: '/detail/6476b05e-876b-4bcb-a5ba-051021af2aa9?topic=manage&offset=1#2',
        },
        {
          title: '如何修改/删除已发布的信息？',
          host: 'forum',
          path: '/detail/6476b05e-876b-4bcb-a5ba-051021af2aa9?topic=manage&offset=1#3',
        },
        {
          title: '如何推广汽车信息？',
          host: 'forum',
          path: '/detail/6476b05e-876b-4bcb-a5ba-051021af2aa9?topic=manage&offset=1#4',
        },
        {
          title: '缺少所需的汽车型号？',
          host: 'forum',
          path: '/detail/6476b05e-876b-4bcb-a5ba-051021af2aa9?topic=manage&offset=1#6',
        },
      ],
      unauthVisible: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(user) {
        // 用户数据加载完成
        if (this.$store.getters.userLoading) return;

        if (!this.user.id) {
          location.replace(hostBuild('/login?redirect=' + hostBuild(this.$route.fullPath, 'house'), 'account'));
          return;
        }

        this.form.contactNumber = user.phone;
        this.form.email = user.email;
        this.form.contactName = user.username;
 
        if ( this.user.phoneAuth == 0 || this.user.phonePrefix != '+1') {
          this.unauthVisible = true;
          return;
        }

        if (this.user.status == 2 || this.user.status == 3) {
          const text = this.user.status == 2 ? '禁言' : '封杀';
          this.$alert(`您已经被${text}，不能进行发布和修改操作！`, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
            callback: () => {
              this.$router.replace('/');
            },
          });
        }
      },
    },
  },
  created() {
    this.getBrands();
    this.getMoulds();
    this.getConfigs();
    this.getTags();

    if (this.$route.query.id) this.getPost();
  },
  methods: {
    getNameById(id,data){
      let name = '';
      for(var i=0; i<data.length; i++){
        if( data[i].id == id) {
          name = data[i].name;
          break;
        }
      }
      return name;
    },
    generateTitle(){
      let name = [];
      console.log(this.form.brand,this.brands);
      if( this.form.year != undefined ){
        
        name.push(this.form.year);
        
      }
      if( this.form.brand != undefined ){
        name.push(this.getNameById(this.form.brand,this.brands))  
      }

      if( this.form.modal != undefined ){
        name.push(this.getNameById(this.form.modal,this.modals));
      }
      this.form.title = name.join(' ')
      console.log(name)
    },
    /**
     * 获取车辆详情
     */
    async getPost() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/car/v1/get/post/detail', {
          postId: this.$route.query.id,
        })
        .finally(() => {
          this.loading = false;
        });

      this.form.imageList = data.imageList;
      this.form.brand = data.property.brand.id;
      this.form.year = data.property.year;
      await this.getModals();
      this.form.modal = data.property.modal.id;
      this.form.mould = data.property.mould.id;
      this.$refs.editor.$data.editor.txt.html(data.content);

      this.form.price = data.property.price && data.property.price / 100;
      this.form.downPayments = data.property.downPayments && data.property.downPayments / 100;
      this.form.monthlySupply = data.property.monthlySupply && data.property.monthlySupply / 100;
      /* if(data.property.topics[0].englishName == 'lease'){
        let lastTime = data.property.lastTime+'';
        let year = lastTime.slice(0, 4);
        let month = lastTime.slice(4, 6);
        this.form.lastTime = `${year}${month}`;
      } */
      if(data.property.topics[0].englishName == 'lease'){
        this.form.lastTime = data.property.lastTime+'';
      }
      
      this.form.existingKM = data.property.existingKM;
      this.form.remainingKM = data.property.remainingKM;

      this.form.gearBox = data.property.gearBox;
      this.form.fuelType = data.property.fuelType;
      this.form.drivingType = data.property.drivingType;
      this.form.config = (data.property.config || []).map(item => item.id);
      this.form.tags = (data.property.tags || []).map(item => item.id);

      this.form.address = data.property.address;
      this.form.cityId = data.property.cityId;
      this.form.showMyDetailAddress = data.property.showMyDetailAddress;
      this.form.longitude = data.location.lon;
      this.form.latitude = data.location.lat;

      this.form.source = data.property.source;
      this.form.contactName = data.property.contactName;
      this.form.email = data.property.email;
      this.form.contactNumber = data.property.contactNumber;

      this.form.title = data.title;
      this.form.preDownPayments = data.property.preDownPayments && data.property.preDownPayments/100;
      this.form.buyout = data.property.buyout==0? data.property.buyout/100:'';
      this.form.deposit = data.property.deposit ==0? data.property.deposit/100:'';
      this.form.transferFeePayer = data.property.transferFeePayer;
      this.form.haveTireInsurance = data.property.haveTireInsurance;
      this.form.haveCarInsurance = data.property.haveCarInsurance;
      this.form.buyerLimit = data.property.buyerLimit;


    },
    /**
     * 新增或修改车辆信息
     */
    async savePost() {
      if (!this.form.imageList.length) return this.$warning('请上传车辆照片');

      if (!this.form.brand) return this.$warning('请选择品牌');
      if (!this.form.year) return this.$warning('请选择年份');
      if (!this.form.modal) return this.$warning('请选择型号');
      if (!this.form.mould) return this.$warning('请选择车型');
  
      if (this.$route.params.topic === 'used') {
        if (this.form.price == null) return this.$warning('请输入价格');
        if (this.form.existingKM == null) return this.$warning('请输入现公里数');
      } else if (this.$route.params.topic === 'lease') {
        if (this.form.preDownPayments == null ) return this.$warning('请输入原首付')
        if (this.form.downPayments == null) return this.$warning('请输入拿回首付');
        if (this.form.monthlySupply == null) return this.$warning('请输入月供');
        if (!this.form.lastTime) return this.$warning('请选择到期时间');
        if (this.form.remainingKM == null) return this.$warning('请输入剩余公里数');
        if (this.form.existingKM == null) return this.$warning('请输入现公里数');
        if (this.form.haveTireInsurance == null ) return this.$warning('请选择有无轮胎险');
        if (this.form.haveCarInsurance == null ) return this.$warning('请选择有无还车保险');
      }
      if( this.form.title == null ) return this.$warning('请输入车辆标题');
      if( this.form.title.replace(/(^\s*)|(\s*$)/g, "").length == 0 )return this.$warning('请输入车辆标题');
      this.form.title = this.form.title.replace(/(^\s*)|(\s*$)/g, "");
      
      /* if (!this.editorText.length) return this.$warning('请输入详细介绍');
      if (this.editorText.length < 5) return this.$warning('详细介绍不能少于5个字'); */
      if (this.editorText.length > 10000) return this.$warning('详细介绍不能超过10000个字');

      if (!this.form.address) return this.$warning('请选择看车地点');
      if (!this.form.cityId) return this.$warning('请选择看车所在城市');
      if (!this.form.latitude) return this.$warning('暂未查询到该地址的位置信息，请重试');

      if (!this.form.source) return this.$warning('请选择车主身份');
      // if (!this.form.contactName) return this.$warning('请输入联系人姓名');
      if (this.form.email && !/^(\w+\.)*\w+@(\w+\.)+[A-Za-z]+/.test(this.form.email))
        return this.$warning('Email 格式不正确');
      if (!/^\d{9,11}$/.test(this.form.contactNumber)) return this.$warning('联系人电话格式不正确');
      if (this.form.weChatId) {
        var wechatReg = /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/;
        if (wechatReg.test(this.form.weChatId) == false) {
          this.$warning('请正确填写微信号');
          return;
        }
      }

      const postId = this.$route.query.id,
        url = postId ? '/car/v1/update/post' : '/car/v1/create/post',
        topic = this.$route.params.topic;

      this.submitLoading = true;
      
      const { data } = await this.$axios
        .post(url, {
          topics: [topicMapping[this.$route.params.topic].id],
          postId,
          ...this.form,
          lastTime: this.form.lastTime ? Number(this.form.lastTime) : null,
          price: this.form.price && this.form.price * 100,
          preDownPayments: this.form.preDownPayments && this.form.preDownPayments * 100,
          downPayments: this.form.downPayments && this.form.downPayments * 100,
          monthlySupply: this.form.monthlySupply && this.form.monthlySupply * 100,
          buyout: this.form.buyout?this.form.buyout * 100:0,
          deposit: this.form.deposit ? this.form.deposit * 100:0,
        })
        .finally(() => {
          this.submitLoading = false;
        });

      if (postId) {
        this.$success('修改成功');
        this.$router.replace(`/detail/${topic}/${postId}`);
      } else {
        this.$success('发布成功');
        var resultUrl = hostBuild("/popularize/promotion/car/" + data.id, 'home');
        window.location.href = resultUrl;
        // this.$router.replace(`/detail/${topic}/${data.id}`);
      }
    },
    /**
     * 地址发生变化
     */
    onAddressChange({ address, cityId, latitude, longitude, showMyDetailAddress }) {
      this.form.address = address;
      this.form.cityId = cityId;
      this.form.latitude = latitude;
      this.form.longitude = longitude;
      this.form.showMyDetailAddress = showMyDetailAddress;
    },
    /**
     * 编辑器内容发生变化
     */
    onEditorContentChange({ html, text }) {
      this.editorText = text;
      this.form.content = html;
    },
    /**
     * 获取汽车品牌列表
     */
    async getBrands() {
      const { data } = await this.$axios.post('/car/v1/get/brand/list', {
        list: 1,
        sortField: 'name',
        sortType: 'ASC',
      });
      this.brands = this.brandFilters = data.list || [];
    },
    /**
     * 获取型号列表
     */
    async getModals() {
      this.form.modal = undefined;
      const { data } = await this.$axios.post('/car/v1/get/model/list', {
        brandId: this.form.brand,
        sortField: 'name',
        sortType: 'ASC',
      });
      this.modals = data || [];
      this.generateTitle();
    },
    /**
     * 获取车型列表
     */
    async getMoulds() {
      const { data } = await this.$axios.post('/car/v1/get/mould/list');
      this.moulds = data || [];
    },
    /**
     * 获取汽车配置列表
     */
    async getConfigs() {
      const { data } = await this.$axios.post('/car/v1/get/configuration/list');
      this.configs = data || [];
    },
    /**
     * 获取标签列表
     */
    async getTags() {
      const { data } = await this.$axios.get('/car/v1/get/tag/tree');
      this.tags = data.tag || [];
    },
    /**
     * 过期时间聚焦时
     */
    onLastTimeFocus() {
      if (!this.form.lastTime) {
        const d = new Date(),
          y = d.getFullYear() + 2,
          m = d.getMonth() + 1;
        this.form.lastTime = `${y}${m}`;
      }
    },
    /**
     * 联系人手机号码发生变化时
     */
    onConcatNumberChange(tel) {
      this.form.contactNumber = tel.replace(/\D/g, '');
    },
    /**
     * 品牌筛选
     */
    brandFilterMethod(keyword) {
      if (keyword) {
        keyword = keyword.toLowerCase();
        this.brandFilters = this.brands.filter(
          brand => brand.name.toLowerCase().indexOf(keyword) > -1 || brand.nameCN.toLowerCase().indexOf(keyword) > -1,
        );
      } else {
        this.brandFilters = [...this.brands];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #f8f8f8;
}
.page-wrapper {
  width: 1170px;
  margin: auto;
  padding-top: 30px;
  display: flex;
  align-items: flex-start;
  padding-bottom: 50px;
}
.page-left {
  flex: 1;
  overflow: hidden;
  background: #ffffff;
  border-radius: 4px;
  padding: 30px 50px 60px;
}
.page-right {
  width: 300px;
  margin-left: 90px;
}
.form-section {
  margin-bottom: 50px;
}
.form-header {
  margin-bottom: 30px;
}
.form-header__name {
  font-size: 18px;
  line-height: 25px;
}
.form-header__required {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--primary-color);
  margin-left: 10px;
}
.form-header__tip {
  font-size: 14px;
  line-height: 17px;
  color: var(--text-color-9);
  margin-left: 30px;
}

.form-upload__tip {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
  margin-top: 25px;
}
.form-radio__list {
  display: flex;
  flex-wrap: wrap;
}
.form-radio__item {
  width: 70px;
  height: 34px;
  background: #f6f6f6;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  color: var(--text-color-3);
  ::v-deep {
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      padding-left: 0;
      color: inherit;
    }
  }
  &.is-checked {
    background-color: rgba(228, 58, 58, 0.1);
    color: var(--primary-color);
  }
}
.form-radio-image__item {
  width: 100px;
  height: 34px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  color: var(--text-color);
  ::v-deep {
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      padding-left: 0;
      color: inherit;
    }
  }
  &.is-checked {
    color: var(--primary-color);
    border-color: var(--primary-color);
    background: url('~@/assets/images/common/checked.jpg') no-repeat right bottom;
  }
}

.form-checkbox__list {
  display: flex;
  flex-wrap: wrap;
}

.form-checkbox__item {
  width: 110px;
  line-height: 36px;
  margin-right: 20px;
}

.form-datepicker__item {
  width: 210px;
}

.form-crossroads {
  display: flex;
}
.form-crossroads__separator {
  font-size: 14px;
  line-height: 34px;
  padding: 0 10px;
  color: var(--text-color-9);
}
.form-input__crossroads {
  width: 125px;
  ::v-deep {
    .el-input__inner {
      padding-right: 20px;
    }
    .el-input__suffix {
      right: 0;
    }
  }
}
.form-input__concatname,
.form-input__concatnumber {
  width: 280px;
}
.form-button__concatnumber {
  margin-left: 15px;
  font-size: 14px;
  color: var(--text-color-3);
  text-decoration: underline;
}
.form-submit {
  text-align: center;
}
.form-button__submit {
  width: 300px;
  height: 50px;
  line-height: 50px;
  padding: 0;
  font-size: 20px;
  margin-bottom: 10px;
}
.form-submit__tip {
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-9);
  margin-top: 12px;
}

.form-input {
  width: 210px;
}
.form-select{width:100%}
.form-select__cn {
  float: left;
  color: #8492a6;
  font-size: 13px;
}

.form-select__en {
  float: right;
}

.form-input__km {
  position: relative;
  &::after {
    content: 'km';
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    font-size: 14px;
    color: var(--text-color-9);
    line-height: 36px;
    width: 30px;
    text-align: center;
  }
  ::v-deep {
    .el-input__inner {
      text-align: start;
      padding-right: 30px;
    }
  }
}
.form-submit {
  text-align: center;
  margin-top: 60px;
}
.required{color:#e43a3a}
.cont-row{display: flex;}
.flex-cont{flex:1;}
.dir-column{ display: flex; flex-direction: column; align-items: flex-start;}
.forum-column-label{font-size:16px; margin-bottom: 10px; line-height: 20px;}

.contact {
  display: flex;
  flex-direction: row;
}

.contact-right {
  padding-left: 30px;
  display: flex;
  justify-content: center;
}
</style>
